<div class="edl-modal-date-picker-content d-flex">
    <form [formGroup]="form" (ngSubmit)="submit(form)" errorTailor>
        <div class="modal-header">
            <h4 class="modal-title">{{title}}</h4>
        </div>
        <div class="modal-body">
            <label class="form-label" for="datePicker">{{label}} <span class="required">*</span></label>
            <div class="d-flex flex-row align-items-center justify-content-between">
                <div class="flex-fill me-4">
                    <edl-date-picker inputId="datePicker" formControlName="datePicker" container="body"></edl-date-picker>
                    <div [style.display]="datePickerControl?.invalid && (datePickerControl?.touched || formSubmitted) ? 'none' : 'block'"
                         style="min-height: 1.5rem;" aria-hidden="true"></div>
                </div>
                <div class="flex-fill">
                    <timepicker formControlName="timePicker" class="text-dark"
                        [attr.aria-invalid]="timePickerControl?.invalid && timePickerControl?.touched ? 'true' : null"
                        [attr.aria-describedby]="timePickerControl?.invalid && timePickerControl?.touched ? 'timePicker-error' : null"></timepicker>
                    <div id="timePicker-error"
                         class="invalid-feedback d-block"
                         [style.visibility]="timePickerControl?.invalid && timePickerControl?.touched ? 'visible' : 'hidden'"
                         [attr.role]="timePickerControl?.invalid && timePickerControl?.touched ? 'alert' : null"
                         style="min-height: 1.5rem;">
                        This field is required.
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="submit" class="btn btn-success">Submit</button>
            <button type="button" class="btn btn-info" (click)="cancel()" autofocus>Cancel</button>
        </div>
    </form>
</div>